export default __webpack_public_path__ + "static/media/no-devices.3426c49a.svg";